import { animate, inView, stagger, spring } from "motion";

export default function initMotionAnimations() {
  inView(".icons-list", ({ target }) => {
    animate(
      target.querySelectorAll(".icons-list > li"),
      { opacity: 1, transform: "translateY(-30px)" },
      { delay: stagger(0.2), duration: 0.7, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".company-logos-list", ({ target }) => {
    animate(
      target.querySelectorAll(".company-logos-list > li"),
      { opacity: 1, transform: "translateY(-30px)" },
      { delay: stagger(0.2), duration: 0.7, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".keywords-list", ({ target }) => {
    animate(
      target.querySelectorAll(".keywords-list > li"),
      { opacity: 1, transform: "none" },
      { delay: stagger(0.2), duration: 0.7, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".numbers-list", ({ target }) => {
    animate(
      target.querySelectorAll(".numbers-list > li"),
      { opacity: 1, transform: "translateY(-30px)" },
      { delay: stagger(0.2), duration: 0.7, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".footer-social-icons", ({ target }) => {
    animate(
      target.querySelectorAll(".footer-social-icons > a"),
      { opacity: 1, transform: "translateY(-30px)" },
      { delay: stagger(0.2), duration: 0.7, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".cards-w-ill-list", ({ target }) => {
    animate(
      target.querySelectorAll(".cards-w-ill-list > li"),
      { opacity: 1, transform: "translateY(-30px)" },
      { delay: stagger(0.2), duration: 0.7, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".module-slogan-w-certification", ({ target }) => {
    target.classList.add("visible");
  });

  inView(".hero-animated-lines", ({ target }) => {
    animate(
      target.querySelectorAll(".line"),
      { transform: "translateY(0%) skewY(0deg)" },
      { delay: stagger(0.3), duration: 0.9, easing: [0.17, 0.8, 0.8, 1] }
    );
  });

  inView(".image-keywords-animated-title", ({ target }) => {
    animate(
      target.querySelectorAll(".line"),
      { transform: "translateY(0%) skewY(0deg)" },
      { delay: stagger(0.3), duration: 0.9, easing: [0.17, 0.8, 0.8, 1] }
    );
  });
}
